<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs6>
      Usuario: {{ userID}}
      <br><br>
      <v-btn
        @click="goTo('/users')"
      >
        Usuarios
      </v-btn>
      <br><br>
      <v-btn
        @click="goTo('/enterprises')"
      >
        Clientes
      </v-btn>
      <br><br>
      <br><br>
      
      <v-btn
        @click="handleLogout"
      >
        Salir
      </v-btn>
      <br>
      {{ isAdmin ? 'true' : 'false' }}
      <br>
      </v-flex>
      <v-flex xs6>
        <simulation 
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Simulation from '@/views/public/mobile/Index'
  export default {
    components: {
      Simulation
    },
    data () {
      return {
      }
    },
    computed: {
      userID () {
        return localStorage.getItem('user')
      },
      isAdmin () {
        return this.$store.state.app.isAdmin
      }
    },
    methods: {
      handleLogout () {
        this.$router.push('/login')
      },
      goTo (value) {
        this.$router.push(value)
      }
    }
  }
</script>

